const CategorySelect = () => {
    // Function to create and insert the select element
    const createSelect = () => {
        // Locate the list and its container
        const list = document.querySelector('.blog-archive__list');
        const container = list ? list.parentNode : null;
        if (container && list) {
            // Avoid creating another select if it already exists
            if (document.querySelector('.blog-archive__select')) return;

            // Create the select element
            const select = document.createElement('select');
            select.className = 'blog-archive__select';

            // Create a default option
            const defaultOption = document.createElement('option');
            defaultOption.text = 'Select Category';  // Option label
            defaultOption.value = '';
            select.appendChild(defaultOption);

            // Loop through each link in the list
            const links = list.querySelectorAll('.blog-archive__link');
            links.forEach(link => {
                const option = document.createElement('option');
                option.text = link.textContent.trim();
                option.value = link.getAttribute('href');

                // Optional: Mark as selected if active
                if (link.classList.contains('blog-archive__link--active')) {
                    option.selected = true;
                }

                select.appendChild(option);
            });

            // Insert the select element before the list in the DOM
            container.insertBefore(select, list);

            // Add change event to handle redirection
            select.addEventListener('change', function() {
                const url = this.value;
                if (url) {
                    window.location.href = url;
                }
            });
        }
    };

    // Function to remove the select element if it exists
    const removeSelect = () => {
        const select = document.querySelector('.blog-archive__select');
        if (select) {
            select.remove();
        }
    };

    // Function to handle the logic based on viewport width
    const handleResize = () => {
        if (window.innerWidth < 769) {
            createSelect();
        } else {
            removeSelect();
        }
    };

    document.addEventListener('DOMContentLoaded', function() {
        // Run the check on page load
        handleResize();

        // Listen for resize events
        window.addEventListener('resize', handleResize);
    });
};

export default CategorySelect;
